<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app id="inspire">
    <v-app-bar app color="indigo" dark v-if="show">
      <v-app-bar-nav-icon
        @click.stop="$store.state.drawer = !$store.state.drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>{{ this.$store.state.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="mx-4">
        <v-chip dark color="indigo darken-4"
          ><v-icon>mdi-currency-usd</v-icon>:
          {{ this.$store.state.rate }}</v-chip
        >
      </div>
      <div class="text-center">
        <v-menu offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-avatar color="indigo" v-bind="attrs" v-on="on">
              <v-icon
                dark
                v-if="
                  $store.state.loggedUser.avatar === '' ||
                    typeof $store.state.loggedUser.avatar === 'undefined'
                "
                >mdi-account-circle</v-icon
              >
              <img v-else :src="$store.state.loggedUser.avatar" />
            </v-avatar>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon
                  v-if="
                    $store.state.loggedUser.avatar === '' ||
                      typeof $store.state.loggedUser.avatar === 'undefined'
                  "
                  >mdi-account-circle</v-icon
                >
                <img v-else :src="$store.state.loggedUser.avatar" />
              </v-list-item-avatar>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title">
                  {{ this.$store.state.loggedUser.fullname }}
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  this.$store.state.loggedUser.jobtitle
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="dialog = !dialog">
              <v-list-item-icon
                ><v-icon>mdi-currency-usd</v-icon></v-list-item-icon
              >
              <v-list-item-title>Update exchange rate</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout()">
              <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="about = !about">
              <v-list-item-icon><v-icon>mdi-xml</v-icon></v-list-item-icon>
              <v-list-item-title> About developers</v-list-item-title>
            </v-list-item>

            <v-list-item @click="support = !support">
              <v-list-item-icon><v-icon>mdi-lifebuoy</v-icon></v-list-item-icon>
              <v-list-item-title> Technical support</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <Drawer v-if="show" />

    <v-main>
      <v-container fluid class="ma-0 pa-0">
        <v-dialog v-model="about" persistent max-width="360">
          <v-card>
            <v-card-title class="headline">About developers</v-card-title>
            <v-card-text>
              <v-img
                class="mt-4 mb-4"
                max-height="100"
                max-width="200"
                src="@/assets/esite_logo.png"
                contain
              />
              <div>
                eSITE Information Technology LLC, Is an Iraqi based software
                development company which is specialized by building customized
                software solutions to all kinds of businesses such as small,
                medium and enterprise levels. We are proud to provide the
                highest quality and latest technologies in the field of web
                applications and mobile applications. Don't hesitate to contact
                us on:
                <br />
                <a href="mailto:info@esite-iq.com">info@esite-iq.com</a> or
                +9647901611249
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="about = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="support" persistent max-width="360">
          <v-card>
            <v-card-title class="headline">Technical Support</v-card-title>
            <v-card-text>
              <div>
                We are here to help you in case if you have faced any bug, error
                or security threat. Don't hesitate to contact us on:
                <br />
                <a href="mailto:info@esite-iq.com">info@esite-iq.com</a> or
                +9647901611249 / +9647700044244
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="support = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" persistent max-width="290">
          <v-form v-model="valid" lazy-validation ref="form" id="new-form">
            <v-card>
              <v-card-title class="headline"
                >Setting exchange rate</v-card-title
              >
              <v-card-text>
                <div>
                  Each day you must set the exchange rate of the U.S dollar in
                  front of Iraqi dinar to ensure the reports are calculated
                  correctly.
                </div>
                <div class="mt-4">
                  <v-text-field
                    v-model="rate"
                    type="number"
                    required
                    @keyup.enter="validate"
                    :rules="amountRules"
                    label="Exchange rate (IQD)"
                    outlined
                  /></div
              ></v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  form="new-form"
                  :disabled="!valid"
                  color="blue darken-1"
                  text
                  @click="validate"
                >
                  Set
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <Login v-if="!show" />
        <router-view v-if="show" class="pa-4" />
      </v-container>
    </v-main>
    <v-footer class="d-none d-md-flex" color="indigo darken-2" app inset>
      <span class="white--text"
        >USS v0.26 R | eSITE Information Technology LLC &copy;
        {{ new Date().getFullYear() }}</span
      >
    </v-footer>
  </v-app>
</template>

<script>
import Drawer from "./components/Drawer";
import Login from "@/views/Login";
import { __HTTP, FormHeader } from "@/utils/utils";
import { eventBus } from "@/main";
export default {
  props: {
    source: String
  },
  components: {
    Drawer,
    Login
  },
  created() {
    this.checkLogin();
    eventBus.$on("login", () => {
      this.$router.push({ path: "/" });
      this.checkTodayRate();
      this.show = true;
    });
    eventBus.$on("logout", () => {
      this.$store.state.loggedUser = null;
      this.show = false;
    });
  },
  methods: {
    logout() {
      //console.log("logout clicked");
      __HTTP("?do=logout", "", FormHeader, null, res => {
        console.log(res);
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.sendEx();
      }
    },
    changeTitle(title) {
      this.title = title;
    },
    checkLogin() {
      //console.log(this.$store.state.loggedUser)
      if (this.$store.state.loggedUser == null) {
        this.show = false;
      } else {
        this.show = true;
        this.checkTodayRate();
      }
    },
    checkTodayRate() {
      __HTTP("?do=checkex", "", FormHeader, res => {
        if (this.$store.state.loggedUser != null) {
          if (!res.exist) {
            this.dialog = true;
          } else {
            this.dialog = false;
            this.$store.state.rate = res.rate;
            this.rate = res.rate;
          }
        } else {
          this.dialog = false;
        }
      });
    },
    sendEx() {
      __HTTP(
        "?do=new&type=exchange",
        JSON.stringify({ rate: this.rate }),
        FormHeader,
        res => {
          if (res.auth) {
            this.dialog = false;
            this.$store.state.rate = this.rate;
          }
        }
      );
    }
  },
  data: () => ({
    title: "Home",
    rate: "0",
    valid: true,
    show: false,
    dialog: false,
    about: false,
    support: false,
    avatar: "",
    amountRules: [
      v => !!v || "Exchange rate is required",
      v =>
        (v && v.length >= 4) ||
        "Exchange rate must be equal or greater than 4 digit."
    ]
    //drawer: null,
  })
};
</script>
